// extracted by mini-css-extract-plugin
export default {"player":"AudioPlayer_player__f9E+3","rotate":"AudioPlayer_rotate__BXJf8"};